var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useContext } from 'react';
import store from 'store';
import ListingFilterSelect from '@michelin/acid-components/build/components/ListingFilters/ListingFilterSelect';
import { checkTransitionAllowed } from '@michelin/acid-components';
import { CentralProviderContext } from '../../../centralProviderContext/CentralProviderContext';
import { Languages, LanguagesArray } from '../../../types/Languages';
import { getTranslations } from '../../../request/getTranslations';
import { updateProfileLanguage } from '../../../request/updateProfileLanguage';
import { clearCacheTranslation } from '../../../helpers/secureCache';
import i18n from '../../../translations/CentralTranslation';
import { useStyles } from '../../../styles/languageStyles';
import { LanguageList } from '../../../constants/languageList';
import { useGetAccessToken } from '../../../hooks/useGetAccessToken';
export var LanguageSwitch = function (_a) {
    var languages = _a.languages, onChange = _a.onChange;
    var classes = useStyles();
    var contextValue = useContext(CentralProviderContext);
    var accessToken = useGetAccessToken();
    var storeKey = "language_".concat(contextValue.application, "_").concat(contextValue.centralProfile.uid);
    var getPossibleLanguage = function () {
        var allowedLanguages = contextValue.allowedLanguages;
        if (store.get(storeKey) && allowedLanguages.includes(store.get(storeKey)))
            return store.get(storeKey);
        if (contextValue.centralProfile
            && allowedLanguages.includes(contextValue.centralProfile.profile.language))
            return contextValue.centralProfile.profile.language;
        return allowedLanguages[0] || Languages.EN_US;
    };
    var selectedLang = React.useRef(getPossibleLanguage());
    var handleChange = function () { return function (currentValue) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, t;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (contextValue.disableTranslationsManager) {
                        store.set(storeKey, currentValue);
                        i18n.changeLanguage(currentValue);
                        contextValue.setCurrentLanguage(currentValue);
                        contextValue.setTranslationLoaded(true);
                        return [2 /*return*/];
                    }
                    _a = onChange;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, onChange()];
                case 1:
                    _a = !(_b.sent());
                    _b.label = 2;
                case 2:
                    if (_a)
                        return [2 /*return*/];
                    selectedLang.current = currentValue;
                    clearCacheTranslation();
                    // translations
                    if (accessToken) {
                        t = getTranslations({
                            application: contextValue.application,
                            language: currentValue,
                            access_token: accessToken,
                            setTranslationLoaded: contextValue.setTranslationLoaded,
                        });
                        if (t) {
                            t.then(function () {
                                updateProfileLanguage({
                                    application: contextValue.application,
                                    language: currentValue,
                                    timezone: contextValue.centralProfile.profile.timezone || 'Etc/UTC',
                                    access_token: accessToken,
                                    userId: contextValue.centralProfile.uid,
                                });
                            });
                        }
                    }
                    store.set(storeKey, currentValue);
                    contextValue.setCurrentLanguage(currentValue);
                    return [2 /*return*/];
            }
        });
    }); }; };
    var filteredLanguages = LanguagesArray.filter(function (language) { return languages.includes(language); });
    if (filteredLanguages.length < 2 || languages.length === 0)
        return null;
    var listOptions = LanguageList.filter(function (language) { return filteredLanguages.includes(language.value); });
    return (React.createElement("div", null,
        React.createElement(ListingFilterSelect, { className: classes.root, value: selectedLang.current, onChange: function (e) {
                checkTransitionAllowed(function (allow) {
                    if (!allow)
                        return;
                    handleChange()(e.target.value);
                });
            }, options: listOptions, disableUnderline: true })));
};
//# sourceMappingURL=LanguageSwitch.js.map